import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { selectPartner } from "../../Main/main.slice";
import AccountPayableHeader from "./AccountPayableHeader";
import TableHeader from "./TableHeader";
import TableFooter from "./TableFooter";
import Loader from "components/Loader/Loader";
import {
  getAllAccountPayables,
  selectState,
  setPaymentCreationPopover,
} from "../accountPayable.slice";
import { useAppDispatch } from "hooks/hooks";
import TableBody from "./TableBody";
import DeleteAccountPayableModal from "./DeleteAccountPayableModal";
import NewPayedPaymentPopover from "./NewPayedPaymentPopover";
import DeletePaidPaymentModal from "./DeletePaidPaymentModal";
import Popover from "components/Popover/Popover";
import { useProjectOptions } from "Dashboard/hooks/ProjectsOptions";

const AccountPayable = () => {
  const dispatch = useAppDispatch();
  const { loading, paymentCreationPopover } = useSelector(selectState);
  const partner = useSelector(selectPartner);
  const projects = useProjectOptions({ showHiddenInDropDowns: true });

  useEffect(() => {
    if (partner) {
      dispatch(getAllAccountPayables(partner.partnerId));
    }
  }, [dispatch, partner?.partnerId]);

  return (
    <>
      <AccountPayableHeader />
      <div className="table-holder loading-container">
        {loading && <Loader />}
        <TableHeader />
        <TableBody projects={projects} />
        <TableFooter />
      </div>
      <DeleteAccountPayableModal />
      <DeletePaidPaymentModal />
      <Popover
        isOpen={paymentCreationPopover.isOpen}
        onClose={() => {
          dispatch(setPaymentCreationPopover({ isOpen: false }));
        }}
        direction="left"
        title="Mi plaćamo - plaćanje"
        arrowStyle={{ top: "40%" }}
        position={{
          top: paymentCreationPopover.top,
          left: paymentCreationPopover.left,
          offsetLeft: -325,
          offsetTop: -88,
        }}
      >
        <NewPayedPaymentPopover />
      </Popover>
    </>
  );
};

export default AccountPayable;
